export const FETCH_BODY_REGIONS = "app/BODY_REGIONS/FETCH_BODY_REGIONS";
export const FETCH_BODY_REGIONS_SUCCESS =
  "app/BODY_REGIONS/FETCH_BODY_REGIONS_SUCCESS";
export const FETCH_BODY_REGIONS_FAILURE =
  "app/BODY_REGIONS/FETCH_BODY_REGIONS_FAILURE";

export const BODY_REGIONS_STORAGE_KEY = "cc.bodyRegions.v1";
